var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "12px",
    viewBox: "0 0 6 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "#585858",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(-1140.000000, -19.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-fb",
    transform: "translate(1131.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(9.818182, 6.545455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71737537,5.45889925 L3.23680352,5.45889925 C3.23680352,7.90194501 3.23680352,10.9090909 3.23680352,10.9090909 L1.04288856,10.9090909 C1.04288856,10.9090909 1.04288856,7.93109649 1.04288856,5.45889925 L0,5.45889925 L0,3.53262979 L1.04288856,3.53262979 L1.04288856,2.2866878 C1.04288856,1.39434953 1.45344575,0 3.25696481,0 L4.88269795,0.00643604183 L4.88269795,1.87629549 C4.88269795,1.87629549 3.89479472,1.87629549 3.70271261,1.87629549 C3.5106305,1.87629549 3.23753666,1.97548625 3.23753666,2.40102219 L3.23753666,3.53300838 L4.90909091,3.53300838 L4.71737537,5.45889925 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.ed1d7313.svg";
export { ForwardRef as ReactComponent };